<template>
  <b-row>
    <b-col sm="12" lg="12">
      <marquee-text
        ref="floatingText"
        :duration="30"
        :repeat="1"
        style="padding-bottom: 5px"
      >
        <b-badge variant="info">Info</b-badge>
        {{ this.portalMsg }}
        <b-badge variant="info">Info</b-badge>
      </marquee-text>
    </b-col>

    <RegionOverview :lgSize="12"></RegionOverview>

    <ActiveBacklog
      v-if="!details"
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      @detailView="switchView"
    ></ActiveBacklog>
    <ActiveBacklog2
      v-else
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      :details="1"
      @detailView="switchView"
      @modalLocation="modalLocation"
    ></ActiveBacklog2>

    <ShippedByFNS
      ref="shipLine"
      v-if="!detailsShip"
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      @detailViewShip="switchViewShip"
    ></ShippedByFNS>
    <ShippedByFNS2
      v-else
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      :details="1"
      @detailViewShip="switchViewShip"
    ></ShippedByFNS2>

    <RepairAnalytics
      v-if="!detailsRepair"
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      @detailViewRepair="switchViewRepair"
    ></RepairAnalytics>
    <RepairAnalytics2
      v-else
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      :details="1"
      @detailViewRepair="switchViewRepair"
    ></RepairAnalytics2>

    <HistoricalData
      v-if="!detailsHistorical"
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      @detailViewHistorical="switchViewHistorical"
    ></HistoricalData>
    <HistoricalData2
      v-else
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      :details="1"
      @detailViewHistorical="switchViewHistorical"
    ></HistoricalData2>
    <YearByUnitStacked
      v-for="item in overviewYears" 
      :key="item" 
      :year="item"
      :lgSize="12"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
    ></YearByUnitStacked>
  </b-row>
</template>

<script>
import ActiveBacklog from "../components/ActiveBacklog-Column";
import ActiveBacklog2 from "../components/ActiveBacklog-Stacked";

import ShippedByFNS from "../components/ShippedByFNS-Column";
import ShippedByFNS2 from "../components/ShippedByFNS-Stacked";

import RepairAnalytics from "../components/RepairAnalytics-Line";
import RepairAnalytics2 from "../components/RepairAnalytics-Stacked";

import HistoricalData from "../components/HistoricalData-Line";
import HistoricalData2 from "../components/HistoricalData-Stacked";

import RegionOverview from "../components/RegionOverview";

import MarqueeText from "vue-marquee-text-component";
import YearByUnitStacked from "../components/YearByUnit-Stacked.vue";
import router from "../router";
import { allowedPath } from "../shared/utils";

export default {
  name: "dashboard",
  components: {
    ActiveBacklog,
    ActiveBacklog2,
    ShippedByFNS,
    ShippedByFNS2,
    RepairAnalytics,
    RepairAnalytics2,
    HistoricalData,
    HistoricalData2,
    RegionOverview,
    YearByUnitStacked
  },
  data: function() {
    return {
      details: false,
      detailsShip: false,
      detailsRepair: false,
      detailsHistorical: false,
      portalMsg: "Welcome to FNS Portal",
      overviewYears: []
    };
  },
  methods: {
    fetchMessage() {
      this.$http.get("api/fns/auth/portalMsg.php").then(
        res => {
          this.portalMsg = res.data.text;
        },
        err => {
          console.log(err);
        }
      );
    },
    switchView() {
      if (this.details == false) {
        this.details = true;
      } else {
        this.details = false;
      }
    },
    switchViewShip() {
      if (this.detailsShip == false) {
        this.detailsShip = true;
      } else {
        this.detailsShip = false;
      }
    },
    switchViewRepair() {
      if (this.detailsRepair == false) {
        this.detailsRepair = true;
      } else {
        this.detailsRepair = false;
      }
    },
    switchViewHistorical() {
      if (this.detailsHistorical == false) {
        this.detailsHistorical = true;
      } else {
        this.detailsHistorical = false;
      }
    },
    generateYears() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let year = currentYear-3; year <= currentYear; year++) {
        years.push(year);
      }
      return this.overviewYears = years;
    }
  },
  beforeMount() {
    allowedPath(
      router.currentRoute.path,
      localStorage.getItem("user_tabs"),
      localStorage.getItem("redirect_path")
    );
  },
  mounted() {
    this.fetchMessage();
    this.generateYears();
  }
};
</script>

<style>
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-label {
  color: #00bf8f !important;
  fill: #00bf8f !important;
}
.markan {
  position: relative;
  /*height: 400px;*/
  .map-container {
    height: 100%;
  }
  .btn-map-fullscreen {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 36px;
    height: 36px;
    padding: 0;
    font-size: 36px;
    line-height: 36px;
    text-align: center;
    outline: none;
  }
  &.fullscreen {
    width: 100%;
    height: 100%;
  }
}
.power {
  background-color: #f86c6b !important;
}
.marquee-text-content {
  width: 100%;
}
.marquee-text-text {
  margin-bottom: 6px;
  margin-top: -4px;
  display: inline-block;
  overflow: hidden;
  text-align: initial;
  white-space: nowrap;
  width: 100%;
  text-align: right;
  animation-iteration-count: 1 !important;
  animation-delay: 5s;
}
</style>
